import React, { memo } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import { useCheckboxStyles } from './styles'

const Checkbox = ({ id, checked, label, name, isDisabled, onChange, ...props }) => {
  const classes = useCheckboxStyles()
  return (
    <label
      className={classnames(classes.checkboxWrapper, {
        disabled: isDisabled
      })}
      htmlFor={id}
      {...props}
    >
      <input checked={checked} id={id} name={name} type="checkbox" onChange={onChange} />
      <span
        className={classnames(classes.checkmark, {
          [classes.checkmarkActive]: checked
        })}
      />
      {label}
    </label>
  )
}

Checkbox.propTypes = {
  checked: PropTypes.bool,
  id: PropTypes.any,
  isDisabled: PropTypes.bool,
  label: PropTypes.node,
  name: PropTypes.string,
  onChange: PropTypes.func
}

Checkbox.defaultProps = {
  onChange: () => {}
}

export default memo(Checkbox)
